import { ReactNode } from "react";

function DosLink({onClick, children}: {onClick: VoidFunction, children: ReactNode}) {
    return (
        <button className="dos-link" onClick={onClick}>{children}</button>
    );
  }

  export default DosLink;
